import React, { useContext } from "react";
import Utils from "../../../Utils";
import previewIcon from "../../../../assets/img/eye-fill.svg";
import ContextComponent from "../../../AppContext";

const PdfCell = ({ props }) => {
  let { setAlert, setCanRedirectToLogin, setLoadingState } =
    useContext(ContextComponent);
  let id = props.data[0]; // unique id
  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    if (res.status === 200) {
      // Convert the response data to a Blob
      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfBlob = blob;
      const downloadUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(downloadUrl, "_blank");

      if (!newWindow) {
        setAlert(
          "Popup blocked! Please allow popups for this website to view the PDF."
        );
        // uncomment the following line to revoke the object URL after the new window is closed
        // because it causes the blob fail to load in the new window
        // newWindow.onload = () => URL.revokeObjectURL(downloadUrl);
      }
    } else {
      console.error("Response is not of type Blob");
    }
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const getReportData = (id) => {
    Utils.getPdfReportById({ Id: id }).then(success, fail);
  };

  const handlePdfDownload = (e) => {
    e.preventDefault();
    getReportData(id);
  };
  return (
    <>
      <span
        role="button"
        onClick={handlePdfDownload}
        className={`indi-table-item-clickable ${id}`}
      >
        <img src={previewIcon} alt="eye-fill-icon" />
      </span>
    </>
  );
};

export default PdfCell;
